export default "__VITE_ASSET__Bzp0BTsx__"